
{
  "familyId": "GET-BREUK-GETALLENLIJN",
  "questions": [
    {
      "id": "GET-BREUK-GETALLENLIJN-001",
      "familyId": "GET-BREUK-GETALLENLIJN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Een getallenlijn loopt van 0 tot 1 en is verdeeld in 4 gelijke stukken. Op welk punt staat ¾?",
      "options": [
        "op het derde streepje",
        "op het tweede streepje",
        "op het vierde streepje",
        "op het eerste streepje"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "breuk_getallenlijn_kwarten",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Strategie: de noemer vertelt in hoeveel stukken de lijn is verdeeld, de teller vertelt hoeveel stukken je telt. Stap 1: De noemer is 4 → de lijn is verdeeld in 4 gelijke stukken. Stap 2: De teller is 3 → tel 3 stukken vanaf 0. Stap 3: Het derde streepje = ¾.",
        "distractorExplanations": {
          "0": "Goed! ¾ = 3 van de 4 stukken. Tel 3 streepjes vanaf 0: dat is het derde streepje.",
          "1": "Veelgemaakte fout: het tweede streepje is ²⁄₄ = ½. Je moet 3 stukken tellen, niet 2.",
          "2": "Veelgemaakte fout: het vierde streepje is ⁴⁄₄ = 1 (het einde van de lijn). ¾ is drie kwart, niet vier kwart.",
          "3": "Veelgemaakte fout: het eerste streepje is ¼. Je moet 3 stukken tellen, niet 1."
        }
      }
    },
    {
      "id": "GET-BREUK-GETALLENLIJN-002",
      "familyId": "GET-BREUK-GETALLENLIJN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Op een getallenlijn van 0 tot 1, verdeeld in 5 gelijke stukken, welke breuk hoort bij het tweede streepje?",
      "options": [
        "²⁄₅",
        "²⁄₃",
        "⅕",
        "½"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "breuk_getallenlijn_vijfden",
      "variantIndex": 2,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Strategie: de verdeling bepaalt de noemer, het streepje bepaalt de teller. Stap 1: De lijn is verdeeld in 5 stukken → noemer = 5. Stap 2: Het tweede streepje → teller = 2. Stap 3: De breuk is ²⁄₅.",
        "distractorExplanations": {
          "0": "Goed! 5 stukken → noemer 5. Tweede streepje → teller 2. Breuk = ²⁄₅.",
          "1": "Veelgemaakte fout: de verkeerde noemer gebruiken. De lijn is verdeeld in 5 stukken, niet 3. De noemer is altijd het totaal aantal stukken.",
          "2": "Veelgemaakte fout: ⅕ is het eerste streepje, niet het tweede. Bij het tweede streepje heb je 2 stukken geteld.",
          "3": "Veelgemaakte fout: ½ zou kloppen als de lijn in 2 stukken was verdeeld. Maar de lijn is in 5 stukken verdeeld, dus het tweede streepje = ²⁄₅."
        }
      }
    },
    {
      "id": "GET-BREUK-GETALLENLIJN-003",
      "familyId": "GET-BREUK-GETALLENLIJN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Waar op de getallenlijn (0 tot 2) ligt de breuk ⁵⁄₄?",
      "options": [
        "tussen 1 en 2",
        "tussen 0 en 1",
        "precies op 1",
        "precies op 2"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "breuk_getallenlijn_groter_dan_1",
      "variantIndex": 3,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Strategie: bepaal of de breuk groter of kleiner is dan 1. Stap 1: ⁵⁄₄ → teller (5) > noemer (4). Stap 2: Als teller > noemer, dan is de breuk groter dan 1. Stap 3: ⁵⁄₄ = 1¼ = 1,25. Stap 4: 1,25 ligt tussen 1 en 2.",
        "distractorExplanations": {
          "0": "Goed! ⁵⁄₄ = 1¼ = 1,25. Dat ligt tussen 1 en 2 op de getallenlijn.",
          "1": "Veelgemaakte fout: denken dat alle breuken kleiner zijn dan 1. ⁵⁄₄ heeft een teller (5) die groter is dan de noemer (4), dus de breuk is groter dan 1.",
          "2": "⁴⁄₄ = 1 (precies op 1). Maar ⁵⁄₄ = 1 + ¼ = 1,25. Dat is meer dan 1.",
          "3": "⁸⁄₄ = 2 (precies op 2). Maar ⁵⁄₄ = 1,25. Dat is minder dan 2."
        }
      }
    },
    {
      "id": "GET-BREUK-GETALLENLIJN-004",
      "familyId": "GET-BREUK-GETALLENLIJN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Een getallenlijn van 0 tot 1 is verdeeld in 8 gelijke stukken. Welke breuk ligt precies op de helft?",
      "options": [
        "⁴⁄₈",
        "⁵⁄₈",
        "³⁄₈",
        "⁸⁄₈"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "breuk_getallenlijn_helft",
      "variantIndex": 4,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Strategie: de helft van de lijn = ½. Zoek de gelijkwaardige breuk met noemer 8. Stap 1: ½ = ?⁄₈. Stap 2: 8 ÷ 2 = 4, dus ½ = ⁴⁄₈. Stap 3: Het vierde streepje op een lijn verdeeld in 8 stukken is precies de helft.",
        "distractorExplanations": {
          "0": "Goed! De helft = ½ = ⁴⁄₈. Op een lijn van 8 stukken is het vierde streepje precies halverwege.",
          "1": "⁵⁄₈ ligt voorbij de helft. 5 van de 8 stukken is meer dan de helft (4 van de 8).",
          "2": "³⁄₈ ligt vóór de helft. 3 van de 8 stukken is minder dan de helft (4 van de 8).",
          "3": "⁸⁄₈ = 1 (het einde van de lijn). De helft is ⁴⁄₈, niet ⁸⁄₈."
        }
      }
    },
    {
      "id": "GET-BREUK-GETALLENLIJN-005",
      "familyId": "GET-BREUK-GETALLENLIJN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Op een getallenlijn van 0 tot 1, verdeeld in 6 stukken, welke twee breuken zijn gelijk?",
      "options": [
        "²⁄₆ en ⅓",
        "²⁄₆ en ½",
        "³⁄₆ en ⅓",
        "⅙ en ⅓"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "breuk_getallenlijn_gelijkwaardig",
      "variantIndex": 5,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Strategie: vereenvoudig de breuken en kijk welke op hetzelfde punt liggen. Stap 1: ²⁄₆ vereenvoudigen: 2 en 6 delen door 2 → ⅓. Stap 2: Dus ²⁄₆ = ⅓ — ze liggen op hetzelfde punt op de getallenlijn. Stap 3: Controleer: ²⁄₆ = 2 van de 6 stukken = ⅓ van de lijn ✓.",
        "distractorExplanations": {
          "0": "Goed! ²⁄₆ = ⅓ (beide delen door 2). Ze liggen op hetzelfde punt op de getallenlijn.",
          "1": "²⁄₆ ≠ ½. ²⁄₆ = ⅓ ≈ 0,33 en ½ = ³⁄₆ = 0,5. Ze liggen op verschillende punten.",
          "2": "³⁄₆ = ½, niet ⅓. ³⁄₆ vereenvoudigd (delen door 3) = ½. ⅓ = ²⁄₆.",
          "3": "⅙ ≠ ⅓. ⅙ is de helft van ⅓. Op de getallenlijn ligt ⅙ op het eerste streepje en ⅓ (= ²⁄₆) op het tweede."
        }
      }
    }
  ]
}
